import React, { useState } from 'react';
import Helpers from '../../lib/helpers';
import Lightbox from "yet-another-react-lightbox";
import Download from "yet-another-react-lightbox/plugins/download";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import "yet-another-react-lightbox/styles.css"

class YetAnotherLightbox extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      indexImage: this.props.indexImage ? this.props.indexImage : 0,
      slides: []
    }
    this.setIndex = this.setIndex.bind(this);
    this.handleClickDownload = this.handleClickDownload.bind(this);
  }

  setIndex = (value) => {
    this.setState({
      indexImage: value
    })
  }

  handleClickDownload() {
    const { slides, indexImage } = this.state;
    const src = slides[indexImage];
    Helpers.downloadImageFile(src.src);
  }

  componentDidMount() {
    const { listImagesMessage } = this.props
    if (listImagesMessage && listImagesMessage.length > 0) {
      let slides = []
      slides = listImagesMessage.map((element) => {
        return {
          src: Helpers.getDownloadURL(element.media_link)
        }
      });
      this.setState({
        slides: slides
      })
    }
  }

  render() {
    const { showModalImage } = this.props;
    const { slides, indexImage } = this.state;
    if (showModalImage && slides[indexImage]) {
      return (<Lightbox
        index={indexImage}
        on={{
          view: ({ index }) => {
            this.setIndex(index)
          }
        }}
        slides={slides}
        open={indexImage >= 0}
        close={() => this.props.setStateIndexImage(-1, false)}
        plugins={[Download, Zoom]}
        carousel={{ finite: slides.length <= 1 }}
        render={{
          buttonPrev: slides.length <= 1 ? () => null : undefined,
          buttonNext: slides.length <= 1 ? () => null : undefined,
          buttonDownload: () => {
            return (
              <button type="button" className="yarl__button" style={{ boxShadow: "none" }} onClick={this.handleClickDownload}>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" focusable="false" className="yarl__icon">
                  <g fill="currentColor">
                    <path d="M0 0h24v24H0z" fill="none">
                    </path>
                    <path d="M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3h-2zm-1-4-1.41-1.41L13 12.17V4h-2v8.17L8.41 9.59 7 11l5 5 5-5z">
                    </path>
                  </g>
                </svg>
              </button>
            )
          }
        }}
        styles={{ button: { boxShadow: "none" } }}
      />)
    }
  }
}
export default YetAnotherLightbox;